// Shared i18n helper for page-level dynamic resource bundles
// Provides language normalization (map zh-* to zh), fallback setup, and namespace bundle injection.

export const normalizeLang = (lng) => {
  if (!lng) return 'en';
  const lower = lng.toLowerCase();
  if (lower.startsWith('zh')) return 'zh';
  return lower;
};

export const ensureNamespace = (i18n, ns, bundles) => {
  const norm = normalizeLang(i18n.language);
  if (norm !== i18n.language) {
    try { i18n.changeLanguage(norm); } catch (_) { /* ignore */ }
  }
  if (!i18n.options.fallbackLng) {
    i18n.options.fallbackLng = ['zh', 'en'];
  }
  Object.entries(bundles).forEach(([lng, data]) => {
    if (!i18n.hasResourceBundle(lng, ns)) {
      i18n.addResourceBundle(lng, ns, data, true, true);
    }
  });
};

// Async variant: ensures bundles added then explicitly loads namespace to emit 'loaded'
export const ensureNamespaceAsync = async (i18n, ns, bundles) => {
  ensureNamespace(i18n, ns, bundles);
  // i18next loadNamespaces triggers 'loaded' event; wrap in Promise to await
  return new Promise((resolve) => {
    i18n.loadNamespaces(ns, () => {
      resolve();
    });
  });
};
